import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useCookies } from 'react-cookie';
import axios from "axios";
import Notifications, {notify} from "react-notify-toast";
import {validateField, validateEmail, validateDate} from "../../../../core/validators";
import {dateToRequestDate} from "../../../../core/date";
import styles from "./PlanCuentasEditModal.module.css";

const PlanCuentasEditModal = ({ show, handleClose, current, callback }) => {

    const loadingBtn = require("../../../../assets/loaders/btn-loading.gif");

    const [cookie, setCookies, removeCookie] = useCookies(['kUserSession']);
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState(current == undefined ? undefined : current.id);
    const [code, setCode] = useState(current == undefined ? undefined : current.codigo);
    const [description, setDescription] = useState(current == undefined ? undefined : current.descripcion);
    const [accountType, setAccountType] = useState(current == undefined ? undefined : current.tipo_cuenta);

    useEffect(() => {
        console.log(current);
        setId(current != undefined ? current.id : undefined);
        setCode(current != undefined ? current.codigo : undefined);
        setDescription(current != undefined ? current.descripcion : undefined);
        setAccountType(current != undefined ? current.tipo_cuenta : undefined);
    }, [current]);    

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    }

    const validateParams = () => {
        return true;
    }

    const update = (body) => {
        setLoading(true);
        axios.put(process.env.REACT_APP_API_URL + "accountancy", body, prepareHeaders()).then(rs => {
            let data = rs.data;
            setLoading(false);
            handleClose();
            notify.show("Cuenta actualizada exitosamente", "success");
            callback();
        }).catch(error => {
            console.error(error.response);
            setLoading(false);
            handleClose();
            notify.show("Ha ocurrido un error al actualizar la cuenta", "error");
        });
    }
    
    const handleSave = (e) => {
        if(validateParams()){
            const body = {
                data: {
                    id_cuenta: id,
                    codigo: parseInt(code),
                    descripcion: description,
                    tipo_cuenta: accountType
                }
            };
            console.log(body);
            update(body);
        }
    }

    return (
        <>
            <Notifications/>
            <Modal show={show} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title><b>Actualizar cuenta</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group controlId="importe">
                                    <Form.Label>Tipo cuenta</Form.Label>
                                    <Form.Control as="select" className="karanda-input" value={accountType} onChange={(e) => { setAccountType(e.target.value); }}>
                                        <option value="P">Pasivo</option>
                                        <option value="A">Activo</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="cuenta">
                                    <Form.Label>Descripción</Form.Label>
                                    <Form.Control className="karanda-input" value={description} onChange={(e) => {setDescription(e.target.value);}} type="text" placeholder="Ingrese la descripción"/>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Cancelar</Button>
                    <Button variant="primary"
                        onClick={handleSave}>
                        {
                            loading ? (
                                <img src={loadingBtn} height="15"/>
                            ) : (<span>Actualizar</span>)
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );

};

export default PlanCuentasEditModal;